import { useSetting } from '$state/hooks/settings';
import { settingsAtom } from '$state/settings';

export function useCenteredChat(centerable = false): boolean {
  const [centeredChat] = useSetting(settingsAtom, 'centeredChat');
  return centerable && centeredChat;
}
